var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _dec7, _dec8, _class2, _class3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import AutoRefreshingTraits from "./AutoRefreshingTraits";
import TableTraits from "./Table/TableTraits";
import UrlTraits from "./UrlTraits";
let PollingTraits = (_dec = primitiveTrait({
  name: "Seconds",
  description: "Time in seconds to wait before polling for new data.",
  type: "number"
}), _dec2 = primitiveTrait({
  name: "url",
  description: "The URL to poll for new data. If undefined, uses the catalog item `url` if there is one.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "shouldReplaceData",
  description: "If true, the new data replaces the existing data, otherwise the new data will be appended to the old data.",
  type: "boolean"
}), _class = class PollingTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "seconds", _descriptor, this);
    _initializerDefineProperty(this, "url", _descriptor2, this);
    _initializerDefineProperty(this, "shouldReplaceData", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "seconds", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "url", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "shouldReplaceData", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);
let CsvCatalogItemTraits = (_dec4 = traitClass({
  description: "Creates one catalog item from url that points to a CSV file that contains geospatial data.",
  example: {
    type: "csv",
    url: "https://tiles.terria.io/static/auspost-locations.csv",
    name: "Australia Post Locations",
    id: "some unique ID"
  }
}), _dec5 = primitiveTrait({
  name: "Character Set",
  description: "The character set of the CSV data, overriding the information provided by the server, if any.",
  type: "string"
}), _dec6 = primitiveTrait({
  name: "CSV Data",
  description: "The actual CSV data, represented as a string.",
  type: "string"
}), _dec7 = primitiveTrait({
  name: "Ignore rows starting with comment",
  description: "Any rows of a CSV starting with '#' or '//' will be ignored. A value of `undefined` will be treated the same as `false`.",
  type: "boolean"
}), _dec8 = objectTrait({
  name: "Polling",
  description: "Polling configuration",
  type: PollingTraits
}), _dec4(_class2 = (_class3 = class CsvCatalogItemTraits extends mixTraits(AutoRefreshingTraits, UrlTraits, TableTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "characterSet", _descriptor4, this);
    _initializerDefineProperty(this, "csvString", _descriptor5, this);
    _initializerDefineProperty(this, "ignoreRowsStartingWithComment", _descriptor6, this);
    _initializerDefineProperty(this, "polling", _descriptor7, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "characterSet", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class3.prototype, "csvString", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class3.prototype, "ignoreRowsStartingWithComment", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "polling", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3)) || _class2);
export { CsvCatalogItemTraits as default };